import { Button } from "@shared/ui/button";
import {
  FieldTooltip,
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
import { PlusIcon } from "lucide-react";
import React, { useState } from "react";
import AddMemberModal from "../addMemberModal/addMemberModal";
import MembersList from "../list/list";
import { Card } from "@shared/ui/card";
import { PageHeader } from "@shared/components/PageHeader";

const Memberslanding = () => {
  const [openAddMemberModal, setOpenAddMemberModal] = useState(false);
  const AddMembersButton = () => {
    const handleCreateTemplate = () => {
      setOpenAddMemberModal(true);
    };

    return (
      <Button onClick={handleCreateTemplate}>
        <PlusIcon className="h-4 w-4 mr-2" />
        Add Member
      </Button>
    );
  };
  return (
    <div className="space-y-6 p-1">
      <Card>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div>
            <PageHeader
              title="List Members"
              subtitle="Manage members for this recipient list"
            />
          </div>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <AddMembersButton />
              </TooltipTrigger>
              <FieldTooltip>Create a new recipient list</FieldTooltip>
            </Tooltip>
          </TooltipProvider>
        </div>
        <div className="mt-4">
          <MembersList />
        </div>
      </Card>
      <AddMemberModal
        openAddMemberModal={openAddMemberModal}
        setOpenAddMemberModal={setOpenAddMemberModal}
      />
    </div>
  );
};

export default Memberslanding;
